export const updateEyesOn = update =>{
    console.dir("EyesonUpdate ");
    console.dir(update);
    return {
        type:"UPDATE_EYESON",
        payload:update
    };
};
